module.exports = __webpack_public_path__ + "static/media/abc.b489a589.png";